import React, { useMemo } from 'react';

import { PROMO_CODES } from '../../constants/promoCodes';
import { formatRecurringPeriodString } from '../paymentComponents/PaymentUtils';


function DisplayPayInfo(props) {
  const { activeCampaign, isPromoPage, program } = props;

  const {
    amount,
    details: {
      trialPeriod,
      trialUnit,
      recurringAmount,
      recurringPeriod,
      recurringPeriodType,
      max,
    },
    currency: { symbol },
  } = program;
  const fee = program.details.fee || 0;

  const correctAmount = useMemo(() => {
    if (recurringAmount) {
      return recurringAmount;
    }

    const decimalPoint = 10000;

    const convertedAmount = amount * decimalPoint;
    const convertedFee = fee * decimalPoint;

    const finalAmount = parseInt(convertedAmount - convertedFee, 10);

    return finalAmount / decimalPoint;
  }, [recurringAmount, amount, fee]);

  const initialAmountToPay = useMemo(() => {
    if ((amount < recurringAmount) && !max) {
      const decimalPoint = 10000;

      const convertedAmount = amount * decimalPoint;
      const convertedFee = fee * decimalPoint;

      const finalAmount = parseInt(convertedAmount - convertedFee, 10);

      return finalAmount / decimalPoint;
    }

    return recurringAmount || correctAmount;
  }, [amount, correctAmount, fee, max, recurringAmount]);

  if (
    isPromoPage &&
    (activeCampaign?.affiliateCode === PROMO_CODES.NNLIVEMRSK4 ||
      activeCampaign?.affiliateCode === PROMO_CODES.ASNAW22)
  ) {
    return null;
  }

  if (trialPeriod && trialUnit && (amount < 1)) {
    return (
      <small className="pay-info">
        Free initially. Rebills {recurringPeriodType.toLowerCase()}ly at {symbol}
        {recurringAmount}
      </small>
    );
  }
  if ((amount && recurringPeriod) || (recurringAmount && (amount !== recurringAmount))) {

    return (
      <small className="pay-info">
        Billed {symbol}
        {initialAmountToPay} first {recurringPeriod > 1 ? recurringPeriod : ''}&nbsp;
        {recurringPeriod > 1 ? `${recurringPeriodType.toLowerCase()}s` : recurringPeriodType}
        . Rebills&nbsp;
        {formatRecurringPeriodString(
          recurringPeriod,
          recurringPeriodType.toLowerCase()
        )}&nbsp;at {symbol}
        {correctAmount}
      </small>
    );
  }


  return (
    <small className="pay-info">
      {`Billed as one payment of ${program.currency.symbol}${correctAmount}`}
    </small>
  );
}

export default DisplayPayInfo;
